import { XpoBaseFeature } from '../base-feature.class';

export abstract class XpoProjectedFeatureBase extends XpoBaseFeature {}
